import { useAuth } from 'modules/auth/ui/hooks/use-auth';

const isDev = process.env.REACT_APP_ENVIRONMENT === 'development';

export const useIsAdmin = (forceValue?: boolean): boolean => {
  const { user } = useAuth();
  if (forceValue !== undefined) return forceValue;
  if (isDev) return true;
  if (!user) return false;
  return user.id === 20;
};
